import { useContext } from 'react'
import { useIntl } from 'react-intl'
import Group from 'components/utils/Group'
import GeoContext from 'contexts/geoContext'
import { TrustIndicatorUK } from 'home/components/UspBanner/TrustIndicatorUk'
import GoogleLongLogo from 'components/Common/TrustIndicators/GoogleLongLogo'
import CSSBreakpoint from 'components/utils/CSSBreakpoint'
import BodyTextBlock from 'LuxKit/TextBlocks/BodyTextBlock'
import TrustPilotLogoCombined from './TrustPilotLogoCombined'
import { TrustIndicatorSingapore } from 'home/components/UspBanner/TrustIndicatorSingapore'

function AccountAccessTrustIndicatorsMapper() {
  const intl = useIntl()
  const { currentRegionCode } = useContext(GeoContext)
  const isUK = currentRegionCode === 'GB'
  const isSG = currentRegionCode === 'SG'

  const googleRating = intl.formatMessage({
    id: 'AFF9frfzVWiHNAba93vz',
    defaultMessage: '4.7/5',
    description: 'Google review rating score displayed on login modal',
  })

  const googleReviews = intl.formatMessage({
    id: 'f2iP-sfiwGgXwdk6j1qW',
    defaultMessage: '(4.5K reviews)',
    description: 'Google review count displayed on login modal in the reviews section',
  })

  const trustpilotRating = intl.formatMessage({
    id: 'Qa6vkig-56ZZedpLygH0',
    defaultMessage: '4.8/5',
    description: 'Trustpilot review rating score displayed on login modal',
  })

  const trustpilotReviews = intl.formatMessage({
    id: 'g_oDDyrbvFj64DtPdyQD',
    defaultMessage: '(13K reviews)',
    description: 'Trustpilot review count displayed on the login modal',
  })

  return (
    <Group direction="horizontal" verticalAlign="center" gap={16} horizontalAlign="center" wrap="wrap">
      {(!isUK && !isSG) && (
        <>
          <Group gap={8} direction="horizontal" verticalAlign="center">
            <GoogleLongLogo width="54" height="18" />
            <BodyTextBlock colour="light-foreground-alt" variant="medium" weight="bold">{googleRating}</BodyTextBlock>
            <CSSBreakpoint min="desktop">
              <BodyTextBlock colour="light-foreground-alt" variant="small">{googleReviews}</BodyTextBlock>
            </CSSBreakpoint>
          </Group>
          <Group gap={8} direction="horizontal" verticalAlign="center">
            <TrustPilotLogoCombined />
            <BodyTextBlock colour="light-foreground-alt" weight="bold" variant="medium" wrap="no-wrap">{trustpilotRating}</BodyTextBlock>
            <CSSBreakpoint min="desktop">
              <BodyTextBlock colour="light-foreground-alt" variant="small" wrap="no-wrap">{trustpilotReviews}</BodyTextBlock>
            </CSSBreakpoint>
          </Group>
        </>
      )}
      {isUK && <TrustIndicatorUK />}
      {isSG && <TrustIndicatorSingapore />}
    </Group>
  )
}

export default AccountAccessTrustIndicatorsMapper
